import { render, staticRenderFns } from "./DestekDetayHeader.vue?vue&type=template&id=19882c63&scoped=true"
import script from "./DestekDetayHeader.vue?vue&type=script&lang=js"
export * from "./DestekDetayHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19882c63",
  null
  
)

export default component.exports